export async function imgCompress(file) {
    let p = await base64Path(file)
    return new Promise(resolve => {
        let fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2);
        const img = new Image();
        img.src = p.toString(); // 指定图片的DataURL(图片的base64编码数据)
        img.onload = () => {
            const canvas = document.createElement('canvas'); // 创建Canvas对象(画布)
            const context = canvas.getContext('2d');
            //默认按比例压缩
            let cw = img.width;
            let ch = img.height;
            let w = img.width;
            let h = img.height;
            canvas.width = w;
            canvas.height = h;
            if (cw > 400 && cw > ch) {
                w = 720;
                h = (720 * ch) / cw;
                canvas.width = w;
                canvas.height = h;
            }
            if (ch > 400 && ch > cw) {
                h = 720;
                w = (720 * cw) / ch;
                canvas.width = w;
                canvas.height = h;
            }
            //生成canvas
            let base64;
            // 创建属性节点
            context.clearRect(0, 0, 0, w, h);
            context.drawImage(img, 0, 0, w, h);
            if (fileSize > 2) {
                //如果图片超过2m,则进行压缩
                base64 = canvas.toDataURL(file['type'], 1);
            } else {
                base64 = p
            }
            let files = dataURLtoFile(base64, file.name);// 将base64转换为file文件
            resolve(files)
            // this.upLoadImg(base64);//图片上传服务的请求方法，这边我就不写出来了！
        };
    })
}

// 将base64转换为file文件
export function dataURLtoFile (dataurl, filename) {
    let arr = dataurl.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    let file = new File([u8arr], filename, {type: mime});
    const data = { //拼成你所需要传给后端的格式
        file:file,
        content:dataurl,
        message:'',
        status:''
    };
    return data
}

export async function base64Path(file) {
    return new Promise(resolve => {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
            return resolve(reader.result)
        }
        reader.onerror = function (error) {
            console.log('Error: ', error)
        }
    })


}